import { Location, Route } from "vue-router";
import providers from "@/lib/api";

export async function resolveUserIdByRoute(to: Route, from: Route, next: (v?: false | string | Location) => void) {
  const userId = Number(to.params.userId);
  if (isNaN(userId) || userId === 0) {
    const userName = to.params.username;
    const data = await providers.UserPublicDataProvider.search({ data: { usernames: [userName] } });
    const user = data.result.find(i => i.username === userName);
    if (user) {
      next({ ...to, name: to.name ?? undefined, params: { ...to.params, userId: user.id } });
    } else {
      next({ name: "home" });
    }
    return;
  } else next();
}
